// File: frontend/src/components/Dashboard/CommercialSummary.jsx
// Resumen comercial del dashboard.
//
// Reemplaza a la tarjeta "Métricas Gerais", que estaba gateada a los roles
// Especialista_Leads / Gerente_Vendas: en prod casi todo el equipo es Super_Admin
// o Admin_Marketing, así que la columna derecha del dashboard salía vacía y la
// página quedaba desbalanceada. Los datos son globales (el backend no expone
// métricas por usuario en estos endpoints), así que no hay motivo para gatearlas.
//
// Sólo métricas que COMPLEMENTAN la fila de KPIs de arriba — nada duplicado.

import React from 'react';

const Row = ({ label, value, hint, accent }) => (
  <div className="flex items-baseline justify-between gap-3 py-2 border-b border-gray-100 dark:border-gray-700 last:border-0">
    <div className="min-w-0">
      <div className="text-sm text-gray-700 dark:text-gray-200 truncate">{label}</div>
      {hint && <div className="text-xs text-gray-400 dark:text-gray-500 truncate">{hint}</div>}
    </div>
    <span className={`text-sm font-semibold tabular-nums flex-shrink-0 ${accent || 'text-gray-900 dark:text-gray-100'}`}>
      {value}
    </span>
  </div>
);

const CommercialSummary = ({ data }) => {
  const n = (v) => (Number(v) || 0).toLocaleString('pt-BR');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5 h-full flex flex-col">
      <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">
        Resumo Comercial
      </h3>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
        Números da base — complementa os KPIs acima
      </p>

      <div className="flex-1">
        <Row
          label="Leads novos"
          hint="últimos 7 dias"
          value={n(data?.leadsLast7Days)}
          accent="text-blue-600 dark:text-blue-400"
        />
        <Row
          label="Leads novos"
          hint="últimos 30 dias"
          value={n(data?.leadsLast30Days)}
        />
        <Row
          label="Leads de alto score"
          hint="banda 7–10"
          value={n(data?.highScoreLeads)}
          accent="text-teal-600 dark:text-teal-400"
        />
        <Row
          label="Oportunidades ativas"
          value={n(data?.openOpportunities)}
          accent="text-violet-600 dark:text-violet-400"
        />
        <Row label="Contatos" value={n(data?.totalContacts)} />
        <Row label="Empresas" value={n(data?.totalCompanies)} />
        <Row
          label="Atividades"
          hint="últimos 30 dias"
          value={n(data?.activities30Days)}
        />
      </div>
    </div>
  );
};

export default CommercialSummary;
